import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { SAVED_SCREENS_QUERY_KEY } from "./useSavedScreens";

export function useDeleteSavedScreen() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (saved_screen_id) => {
      const { error } = await client.DELETE("/api/screens/{saved_screen_id}", {
        params: { path: { saved_screen_id } },
      });
      if (error !== undefined) {
        throw new Error("Failed to delete saved screen");
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_SCREENS_QUERY_KEY });
    },
  });
}
